import React from "react";
import { Route, Switch } from "react-router-dom";
import asyncComponent from "util/asyncComponent";
import Dashboard from "./main/dashboard/index";
import Clients from "./Clients";
import UsersContext from "../contextApi/UsersContext";
import ClientContext from "../contextApi/ClientContext";
import AssetContext from "../contextApi/AssetContext";

const App = ({ match }) => (
  <div className="gx-main-content-wrapper">
    {/* Users, CLient, Asset Context wrap */}
    <UsersContext>
      <ClientContext>
        <AssetContext>
          {/* Routing Start */}
          <Switch>
            <Route path={`${match.url}dashboard`} component={Dashboard} />
            <Route
              path={`${match.url}assets`}
              component={asyncComponent(() => import("./Assets"))}
            />
            <Route path={`${match.url}clients`} component={Clients} />
            <Route
              path={`${match.url}corporateadmin`}
              component={asyncComponent(() => import("./CorporateAdmin"))}
            />
            <Route
              path={`${match.url}users`}
              component={asyncComponent(() => import("./Users"))}
            />
            <Route
              path={`${match.url}reports`}
              component={asyncComponent(() => import("./Reports"))}
            />
            <Route
              path={`${match.url}dashboardData`}
              component={asyncComponent(() => import("./DashboardData"))}
            />
          </Switch>
          {/* Routing End */}
        </AssetContext>
      </ClientContext>
    </UsersContext>
  </div>
);

export default App;
